var React = require('react');

function Prevarrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.99925 12.28L1.65258 7.9333C1.13924 7.41997 1.13924 6.57997 1.65258 6.06664L5.99925 1.71997","stroke":"#292D32","strokeWidth":"1.5","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Prevarrow.defaultProps = {"width":"7","height":"14","viewBox":"0 0 7 14","fill":"none"};

module.exports = Prevarrow;

Prevarrow.default = Prevarrow;
